/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TakeNativeSnapshotRequest {
  /**
  * Number of days to retain the native snapshot.
  */
  'retentionDays': number;
  /**
  * AWS region where the backup should be stored. If not specified, the backup is stored in the same region as the source resource. Use this for cross-region backup scenarios (e.g., disaster recovery). 
  */
  'targetRegion'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    },
    {
      "name": "targetRegion",
      "baseName": "targetRegion",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TakeNativeSnapshotRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

